import { clientsDao } from '@/service';

export default {
  state: {},
  mutations: {},
  actions: {
    // clients
    async getAllClients(_, payload) {
      const config = {
        params: {
          perPage: payload.perPage,
          page: payload.page,
          workspace_id: payload.workspace_id,
          search: payload.search,
        },
      };
      return new Promise((resolve, reject) => {
        clientsDao
          .getAll(config)
          .getPage()
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async getClient(_, payload) {
      return new Promise((resolve, reject) => {
        clientsDao
          .getClient(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    async createClient(_, payload) {
      return new Promise((resolve, reject) => {
        clientsDao
          .createClient(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    async updateClient(_, payload) {
      return new Promise((resolve, reject) => {
        clientsDao
          .updateClient(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async deleteClient(_, payload) {
      return new Promise((resolve, reject) => {
        clientsDao
          .deleteClient(payload)
          .then(async (resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  getters: {},
};
